<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii">
<p class="title">IMAGES OF WAR</p>
<h1 class="title1"><span class="bold">JAPAN TRIUMPHANT</span></h1>
<p class="subtitle"><em class="italic">The Far East Campaign</em></p>
<p class="subtitle1"><em class="italic">1941–1942</em></p>
<p class="subtitle2">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</p>
<p class="author">Philip Jowett</p>
<div class="pub"><img alt="image" src="images/pub1.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?2583113a